import React, { type ReactNode } from "react";
import type { VideoTypes } from "@bloomberg/media-ui-av";

import {
    DEFAULT_CONTEXT_OPTIONS,
    VideoPlayerContext,
} from "./VideoPlayerContext";

export type VideoPlayerProviderProps = VideoPlayerContext & {
    children: ReactNode;
};

export interface LineupVideoPlayerProps {
    onError?: VideoTypes.CallbackFunction<unknown>;
}

export function VideoPlayerProvider(
    props: VideoPlayerProviderProps
): JSX.Element {
    const { children } = props;

    const videoPlayerContextValue = {
        ...DEFAULT_CONTEXT_OPTIONS,
        ...props,
    };

    return (
        <VideoPlayerContext.Provider value={videoPlayerContextValue}>
            {children}
        </VideoPlayerContext.Provider>
    );
}
